import { render } from "./ExtendedWarrantyForFigPlanSelector.vue?vue&type=template&id=075db234&scoped=true&ts=true"
import script from "./ExtendedWarrantyForFigPlanSelector.vue?vue&type=script&lang=ts"
export * from "./ExtendedWarrantyForFigPlanSelector.vue?vue&type=script&lang=ts"

import "./ExtendedWarrantyForFigPlanSelector.vue?vue&type=style&index=0&id=075db234&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075db234"]])

export default __exports__